<template>
  <div class="container">
    <div v-if="$route.query.id" class="header">编辑欢迎语</div>
    <div v-else class="header">新建欢迎语</div>
    <div class="main">
      <el-form ref="ruleForm" :model="form" :rules="rules" label-width="12.0rem">
        <div class="form-header">
          <el-form-item prop="scope" label="成员：">
            <el-radio-group v-model="form.scope" @change="changeScope">
              <el-radio :label="1">通用</el-radio>
              <el-radio :label="2">仅企业员工适用</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.scope === 2" label="添加成员：" prop="userid">
            <div class="person">
              <el-tag v-for="item of names" :key="item" effect="plain"  style="margin-right:12px;">
                {{ item }}
              </el-tag>
            </div>
            <el-button class="addBtn" icon="el-icon-plus" @click="addContact">前往添加</el-button>
          </el-form-item>
        </div>
        <div class="form-content">
          <el-form-item prop="content" label="欢迎语内容：">
            <el-input clearable type="textarea" autosize="true" placeholder="请输入内容" v-model="form.content"></el-input>
          </el-form-item>
          <el-form-item prop="type" label="其它类型：">
            <el-radio-group v-model="form.type" @change="changeType">
              <el-radio label="无">无</el-radio>
              <el-radio label="图片">图片</el-radio>
              <el-radio label="图文">图文</el-radio>
              <el-radio label="小程序">小程序</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item prop="mini_name" v-if="form.type === '小程序'" label="小程序名称：">
            <el-input clearable v-model="form.mini_name" placeholder="请输入小程序名称"></el-input>
          </el-form-item>
          <el-form-item prop="mini_id" v-if="form.type === '小程序'" label="小程序ID：">
            <el-input clearable v-model="form.mini_id" placeholder="请输入小程序ID"></el-input>
          </el-form-item>
          <el-form-item prop="link_url" v-if="form.type === '小程序'" label="小程序路径：">
            <el-input clearable v-model="form.link_url" placeholder="请输入小程序路径"></el-input>
          </el-form-item>
          <el-form-item prop="title" v-if="form.type === '小程序'" label="小程序标题：">
            <el-input clearable v-model="form.title" placeholder="请输入小程序标题"></el-input>
          </el-form-item>
          <el-form-item prop="title" v-if="form.type === '图文'" label="标题：">
            <el-input clearable v-model="form.title" placeholder="请输入标题"></el-input>
          </el-form-item>
          <el-form-item prop="link_url" v-if="form.type === '图文'" label="链接：">
            <el-input clearable v-model="form.link_url" placeholder="请输入链接"></el-input>
          </el-form-item>
          <el-form-item prop="url" v-if="
            form.type === '图片' ||
            form.type === '图文' ||
            form.type === '小程序'
          " :label="form.type === '小程序' ? '封面：' : form.type + '：'">
            <el-upload class="upload-demo" :action="
              this.axios.defaults.baseURL +
              '/api/Alioss/upload_temp_uploadimg'
            " :data="upParams" :on-preview="handlePreview" :on-remove="handleRemove"
              :before-upload="handleBeforeUpload" :on-success="handleSuccess" :before-remove="beforeRemove"
              :on-exceed="handleExceed" :file-list="fileList" :list-type="listType" :accept="accept" :limit="1">
              <el-button type="primary">
                上传{{ form.type === "小程序" ? "封面" : form.type }}
                <i class="el-icon-upload el-icon--right"></i>
              </el-button>
              <div slot="tip" class="el-upload__tip">{{ tip }}</div>
            </el-upload>
          </el-form-item>
          <el-form-item v-if="form.type === '图文'" prop="describe" label="描述：">
            <el-input clearable type="textarea" autosize="true" placeholder="请输入描述" v-model="form.describe"></el-input>
          </el-form-item>
        </div>
        <div class="form-footer">
          <el-form-item label-width="3.0rem">
            <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
            <el-button style="margin-left:2.0rem;" plain @click="$router.back()">取消</el-button>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <el-dialog center :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt />
    </el-dialog>
    <right-people ref="dialog" :checkbox="checkbox" @handleSelect="handleSelect"></right-people>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";
import rightPeople from '@/components/drawer/rightPeople';
export default {
  components: {
    rightPeople
  },
  data() {
    return {
      form: {
        scope: 1,
        content: "",
        title: "",
        type: "无",
        url: "",
        link_url: "",
        describe: "",
        mini_name: "",
        mini_id: "",
        userid: "",
        media_id: "",
        user_list: []
      },
      rules: {
        content: [
          { required: true, message: "请输入欢迎语内容", trigger: "blur" },
        ],
        title: [{ required: true, message: "请输入标题", trigger: "blur" }],
        type: [{ required: true, message: "请选择其它类型", trigger: "blur" }],
        desc: [{ required: true, message: "请输入描述", trigger: "blur" }],
        url: [{ required: true, message: "请选择文件", trigger: "blur" }],
        link_url: [{ required: true, message: "请输入链接", trigger: "blur" }],
        describe: [{ required: true, message: "请输入描述", trigger: "blur" }],
        mini_name: [
          { required: true, message: "请输入小程序名称", trigger: "blur" },
        ],
        mini_id: [
          { required: true, message: "请输入小程序ID", trigger: "blur" },
        ],
      },
      fileList: [],
      // 上传图片地址
      imageUrl: "",
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
      accept: "",
      listType: "",
      tip: "",
      tooken: "",
      checkbox: false,
      names: [],
      upParams: {},
      module: ''
    };
  },
  mounted() {
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      this.tooken = userinfo;
      this.upParams.account_id = this.tooken.account_id;
    }
    if (!this.$route.query.id) {
      this.form.type = "无";
      return;
    }
    this.getData();
  },
  methods: {
    getData() {
      this.axios
        .post(
          "/crm/Assistant/getWelcomeOne",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            id: this.$route.query.id,
          }),
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        )
        .then((res) => {
          if (res.data.code == 1) {
            const data = res.data.data;
            this.form.content = data.content;
            this.form.title = data.title;
            this.form.type = data.type;
            this.form.user_name = data.user_name;
            this.form.scope = data.scope;
            this.form.url = data.url;
            this.form.media_id = data.media_id;
            this.form.link_url = data.link_url;
            this.form.describe = data.describe;
            this.form.mini_name = data.mini_name;
            this.form.mini_id = data.mini_id;
            // this.userid = data.userid;
            this.names = [data.user_name]
            this.fileList.push({ url: data.url, name: data.file_name });
            this.setAccept();
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) { });
    },
    changeType() {
      this.form.title = "";
      this.form.user_name = "";
      this.form.url = "";
      this.form.media_id = "";
      this.form.link_url = "";
      this.form.describe = "";
      this.form.mini_name = "";
      this.form.mini_id = "";
      // this.userid = "";
      this.setAccept();
    },
    setAccept() {
      switch (this.form.type) {
        case "图片":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "图文":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        case "小程序":
          this.listType = "picture";
          this.tip = "只能上传JPG,PNG格式文件，且不超过2MB";
          this.accept = ".jpg,.png";
          break;
        default:
          break;
      }
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) { },
    handleBeforeUpload(file) {
      const size = file.size / 1024 / 1024;
      if (this.form.type === "图片" || this.form.type === "链接") {
        if (size > 2) {
          this.$message({
            message: "上传图片文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "视频") {
        if (size > 10) {
          this.$message({
            message: "上传视频文件过大",
            type: "error",
          });
          return false;
        }
      }
      if (this.form.type === "文件") {
        if (size > 20) {
          this.$message({
            message: "上传文件过大",
            type: "error",
          });
          return false;
        }
      }
    },
    handleSuccess(response, file, fileList) {
      this.form.url = response.data.url;
      this.form.media_id = response.data.media_id;
      this.fileList.push(this.form.url);
      this.$message({
        message: response.msg,
        type: "success",
      });
    },
    beforeRemove(file, fileList) {
      this.form.url = [];
      this.fileList = [];
    },
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    },
    addContact() {
      this.module = 'getAddressBook'
      this.checkbox = true;
      this.isGroup = true;
      this.$refs.dialog.open();
    },
    handleSelect(person) {
      switch (this.module) {
        case "getWelcomeOne":
          this.form.userid = person.userid;
          this.names = String(user);
          break;
        case "getAddressBook":
          const userid = [];
          const user = [];
          person.map((item) => {
            userid.push(item.userid);
            user.push(item.name);
          });
          this.form.userid = userid.join();
          this.names = user;
          console.log(this.names);
          break;
        default:
          break;
      }
    },
    changeScope(label) {
      switch (label) {
        case "1":
          Reflect.deleteProperty(this.rules, "userid");
          break;
        default:
          this.rules.userid = [
            {
              required: true,
              message: "请选择成员",
              trigger: "blur",
            },
          ];
          break;
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submit();
        } else {
          return false;
        }
      });
    },
    submit() {
      const url = this.$route.query.id ? "editWelcome" : "addWelcome";
      if (this.form.userid == "") {
        this.axios
          .post(
            `/crm/Assistant/${url}`,
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              id: this.$route.query.id,
              scope: this.form.scope,
              type: this.form.type,
              content: this.form.content,
              title: this.form.title,
              url: this.form.url,
              link_url: this.form.link_url,
              link_title: this.form.linkTitle,
              describe: this.form.describe,
              mini_name: this.form.mini_name,
              mini_id: this.form.mini_id,
              media_id: this.form.media_id,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.$router.go(-1);
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) { });
      } else {
        this.axios
          .post(
            `/crm/Assistant/${url}`,
            qs.stringify({
              usertoken: this.tooken.usertoken,
              account_id: this.tooken.account_id,
              phone: this.tooken.phone,
              id: this.$route.query.id,
              scope: this.form.scope,
              type: this.form.type,
              content: this.form.content,
              title: this.form.title,
              url: this.form.url,
              link_url: this.form.link_url,
              link_title: this.form.linkTitle,
              describe: this.form.describe,
              mini_name: this.form.mini_name,
              mini_id: this.form.mini_id,
              userid: this.form.userid,
              media_id: this.form.media_id,
            }),
            { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
          )
          .then((res) => {
            if (res.data.code == 1) {
              this.$message.success(res.data.msg);
              this.$router.go(-1);
            } else if (res.data.code == 0) {
              this.$message.error(res.data.msg);
            }
          })
          .catch(function (err) { });
      }
    },
  },
};
</script>
<style scoped>
.header {
  line-height: 4.0rem;
  border-bottom: .1rem solid rgb(241, 239, 239);
}

.addBtn {
  margin-top: 2.0rem;
}

.main {
  margin-top: 4.0rem;
}

.form-header,
.form-content {
  padding-top: 22px;
  padding-right: 22px;
  overflow: hidden;
}

.form-content,
.form-footer {
  margin-top: 2.0rem;
}

.el-upload-list__item-thumbnail {
  width: 10.0rem;
  height: 10.0rem;
}
</style>
